// extracted by mini-css-extract-plugin
export default {"firstColumn":"Consignment-module_firstColumn__vVsh8"};